import { DOCUMENT, CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵinject, Inject, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, Optional, SkipSelf, ɵɵdefineDirective, ɵɵProvidersFeature, Directive, ɵɵdirectiveInject, Injector, ɵɵNgOnChangesFeature, Input, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHeaders, HttpParams, HttpClient, HttpUrlEncodingCodec } from '@angular/common/http';
import { Router } from '@angular/router';
import moment from 'moment';
import { map, catchError } from 'rxjs/operators';
import { NG_VALIDATORS, Validators, NgControl, FormsModule } from '@angular/forms';

class Page {
}

class Sistema {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const sistema = new Sistema();
        sistema.id = json.id;
        sistema.codigo = json.codigo;
        sistema.nombre = json.nombre;
        sistema.url = json.url;
        sistema.descripcion = json.descripcion;
        sistema.urlLogo = json.urlLogo;
        return sistema;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            codigo: this.codigo,
            nombre: this.nombre,
            url: this.url,
            descripcion: this.descripcion,
            urlLogo: this.urlLogo,
        };
    }
}

class UsuarioSimple {
    get nombreCompleto() {
        if (this.nombre && this.apellidos) {
            return this.nombre + ' ' + this.apellidos;
        }
        else if (this.nombre) {
            return this.nombre;
        }
        else if (this.email) {
            return this.email;
        }
        return '';
    }
    static fromJSON(json) {
        const usuarioSimple = new UsuarioSimple();
        usuarioSimple.id = json.id;
        usuarioSimple.email = json.email;
        usuarioSimple.nombre = json.nombre;
        usuarioSimple.apellidos = json.apellidos;
        return usuarioSimple;
    }
    toJSON() {
        return {
            id: this.id,
            email: this.email,
            nombre: this.nombre,
            apellidos: this.apellidos,
        };
    }
}

class Marca {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const cadena = new Marca();
        cadena.id = json.id;
        cadena.nombre = json.nombre;
        cadena.url = json.url;
        return cadena;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            url: this.url,
        };
    }
}

class Sector {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const cargo = new Sector();
        cargo.id = json.id;
        cargo.nombre = json.nombre;
        return cargo;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class TipoCliente {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const cargo = new TipoCliente();
        cargo.id = json.id;
        cargo.nombre = json.nombre;
        return cargo;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class Cadena {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const cadena = new Cadena();
        cadena.id = json.id;
        cadena.nombre = json.nombre;
        cadena.nombreFiscal = json.nombreFiscal;
        cadena.cif = json.cif;
        cadena.domicilio = json.domicilio;
        cadena.tipoCliente = json.tipoCliente ? TipoCliente.fromJSON(json.tipoCliente) : null;
        cadena.sector = json.sector ? Sector.fromJSON(json.sector) : null;
        cadena.url = json.url;
        if (json.marcas) {
            cadena.marcas = json.marcas.map((m) => Marca.fromJSON(m));
        }
        cadena.responsable = json.responsable ? UsuarioSimple.fromJSON(json.responsable) : null;
        cadena.referenciante = json.referenciante;
        return cadena;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            nombreFiscal: this.nombreFiscal,
            cif: this.cif,
            domicilio: this.domicilio,
            tipoCliente: this.tipoCliente ? this.tipoCliente.toJSON() : null,
            sector: this.sector ? this.sector.toJSON() : null,
            url: this.url,
            marcas: this.marcas ? this.marcas.map((m) => m.toJSON()) : null,
            responsable: this.responsable ? this.responsable.toJSON() : null,
            referenciante: this.referenciante,
        };
    }
}

class DatabaseConstants {
    constructor() {
        this.tipEstHotelId = 1;
        this.tipEstRestauranteId = 2;
        this.tipEstComercioId = 4;
        this.dimHabitacion = 2;
        this.dimInstComunes = 3;
        this.deptConLugarIds = [3, 10, 11, 20, 21, 25, 52];
    }
    static getInstance() {
        return this.instance || (this.instance = new this());
    }
}

class TipoEstablecimiento {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const tipoEstablecimiento = new TipoEstablecimiento();
        tipoEstablecimiento.id = json.id;
        tipoEstablecimiento.nombre = json.nombre;
        return tipoEstablecimiento;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class Zona {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const zona = new Zona();
        zona.id = json.id;
        zona.nombre = json.nombre;
        if (json.subzonas != null) {
            zona.subzonas = json.subzonas.map((zonaJSON) => {
                const subzona = Zona.fromJSON(zonaJSON);
                subzona.superzona = zona;
                return subzona;
            });
        }
        return zona;
    }
    static flatten(zonas, level = 0) {
        let result = [];
        for (const zona of zonas) {
            result.push(zona);
            result = result.concat(this.flatten(zona.subzonas, level + 1));
        }
        return result;
    }
    static filter(zonas, zonaIds) {
        const result = [];
        for (const zona of zonas) {
            for (const zonaId of zonaIds) {
                if (zona.isSelfOrChildren(zonaId)) {
                    result.push(zona);
                    break;
                }
            }
        }
        return result;
    }
    getLevel() {
        let level = 0;
        let z = this;
        while (z.superzona != null) {
            z = z.superzona;
            level += 1;
        }
        return level;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            superzona: this.superzona != null ? this.superzona.toJSON() : null,
            subzonas: null,
        };
    }
    isSelfOrChildren(zonaId) {
        if (this.id === zonaId) {
            return true;
        }
        if (this.subzonas != null) {
            for (const subzona of this.subzonas) {
                if (subzona.isSelfOrChildren(zonaId)) {
                    return true;
                }
            }
        }
        return false;
    }
}

class Establecimiento {
    get urlWithFallback() {
        if (this.url) {
            return this.url;
        }
        else if (this.marca && this.marca.url) {
            return this.marca.url;
        }
        else if (this.cadena) {
            return this.cadena.url;
        }
        return null;
    }
    get shortNameWithFallback() {
        return this.nombreCorto && this.nombreCorto !== '' ? this.nombreCorto : this.getLongNameShorted();
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const establecimiento = new Establecimiento();
        establecimiento.id = json.id;
        establecimiento.nombre = json.nombre;
        establecimiento.nombreCorto = json.nombreCorto;
        establecimiento.domicilio = json.domicilio;
        establecimiento.categoria = json.categoria;
        establecimiento.orden = json.orden;
        establecimiento.cadena = json.cadena ? Cadena.fromJSON(json.cadena) : null;
        establecimiento.marca = json.marca ? Marca.fromJSON(json.marca) : null;
        establecimiento.zona = json.zona ? Zona.fromJSON(json.zona) : null;
        establecimiento.tipoEstablecimiento = json.tipoEstablecimiento
            ? TipoEstablecimiento.fromJSON(json.tipoEstablecimiento)
            : null;
        establecimiento.url = json.url;
        return establecimiento;
    }
    isHotel() {
        return this.tipoEstablecimiento.id === DatabaseConstants.getInstance().tipEstHotelId;
    }
    isRestaurante() {
        return this.tipoEstablecimiento.id === DatabaseConstants.getInstance().tipEstRestauranteId;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            nombreCorto: this.nombreCorto,
            domicilio: this.domicilio,
            categoria: this.categoria,
            orden: this.orden,
            cadena: this.cadena ? this.cadena.toJSON() : null,
            marca: this.marca ? this.marca.toJSON() : null,
            zona: this.zona ? this.zona.toJSON() : null,
            tipoEstablecimiento: this.tipoEstablecimiento ? this.tipoEstablecimiento.toJSON() : null,
            url: this.url,
        };
    }
    getLongNameShorted() {
        return this.nombre && this.nombre !== '' ? this.nombre.substring(0, Math.min(15, this.nombre.length)) : null;
    }
}

class UsuarioSistema {
    constructor() {
        this.roles = [];
    }
    get rol() {
        return this.roles.length > 0 ? this.roles[0] : null;
    }
    set rol(rol) {
        this.roles = [rol];
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const usuario = new UsuarioSistema();
        usuario.sistema = json.sistema != null ? Sistema.fromJSON(json.sistema) : null;
        usuario.establecimientos =
            json.establecimientos != null
                ? json.establecimientos.map((establecimientoJSON) => Establecimiento.fromJSON(establecimientoJSON))
                : null;
        usuario.cadena = json.cadena != null ? Cadena.fromJSON(json.cadena) : null;
        usuario.zona = json.zona != null ? Zona.fromJSON(json.zona) : null;
        usuario.roles = json.roles;
        return usuario;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            sistema: this.sistema != null ? this.sistema.toJSON() : null,
            establecimientos: this.establecimientos != null ? this.establecimientos.map((establecimiento) => establecimiento.toJSON()) : null,
            cadena: this.cadena != null ? this.cadena.toJSON() : null,
            zona: this.zona != null ? this.zona.toJSON() : null,
            roles: this.roles,
        };
    }
}

class Usuario extends UsuarioSimple {
    set contraseña(newValue) {
        this._contraseña = newValue;
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const usuario = Object.assign(new Usuario(), super.fromJSON(json));
        usuario.accessToken = json.accessToken;
        if (json.usuarioSistemas != null) {
            usuario.usuarioSistemas = json.usuarioSistemas.map((usuarioSistemaJSON) => UsuarioSistema.fromJSON(usuarioSistemaJSON));
        }
        return usuario;
    }
    hasRoleIn(sistema, ...roles) {
        const usuarioSistema = (this.usuarioSistemas || []).find((us) => us.sistema.codigo === sistema);
        return usuarioSistema ? (usuarioSistema.roles || []).some((rol) => roles.indexOf(rol) > -1) : false;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return Object.assign(super.toJSON(), {
            accessToken: this.accessToken,
            usuarioSistemas: this.usuarioSistemas != null ? this.usuarioSistemas.map((usuariosistema) => usuariosistema.toJSON()) : null,
            contraseña: this._contraseña,
        });
    }
}

class LibConfig {
}
LibConfig.ɵfac = function LibConfig_Factory(t) { return new (t || LibConfig)(); };
LibConfig.ɵprov = ɵɵdefineInjectable({ token: LibConfig, factory: LibConfig.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LibConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class ErrorHandlingService {
    handlePromiseError(error) {
        console.error('An error occurred', error);
        return Promise.reject(error);
    }
}
ErrorHandlingService.ɵfac = function ErrorHandlingService_Factory(t) { return new (t || ErrorHandlingService)(); };
ErrorHandlingService.ɵprov = ɵɵdefineInjectable({ token: ErrorHandlingService, factory: ErrorHandlingService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorHandlingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class UsuarioService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.usuariosUrl = `${this.libConfig.baseUrl}/resources/Usuarios`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getUsuarios(page, size, search, sort, order) {
        // From the [URLSearchParams docs](https://angular.io/api/http/URLSearchParams):
        // These are the characters that are not encoded: ! $ \' ( ) * + , ; A 9 - . _ ~ ? /
        //
        // If the set of allowed query characters is not acceptable for a particular backend,
        // QueryEncoder can be subclassed and provided as the 2nd argument to URLSearchParams.
        // A + is a valid symbol in an e-mail address. For example "testuser+github@gmail.com".
        // IETF RFC 3986 lists "+" as one of the characters that is valid in a query string parameter.
        // That's true, it is valid if it's intended as a space. What happens with the e-mail above,
        // is that when it reaches the server, the server interprets it as "testuser github@gmail.com"
        // and predictably can't find a corresponding e-mail address.
        // https://github.com/angular/angular/issues/18261
        let params = new HttpParams({ encoder: new MyQueryEncoder() });
        params = params.set('page', String(page));
        params = params.set('size', String(size));
        if (search) {
            params = params.set('search', search);
        }
        if (sort) {
            params = params.set('sort', sort);
        }
        if (order) {
            params = params.set('order', order);
        }
        return this.http
            .get(this.usuariosUrl, { params })
            .toPromise()
            .then((response) => {
            const userPage = new Page();
            userPage.items = response.usuarios.map((encuestasJSON) => Usuario.fromJSON(encuestasJSON));
            userPage.count = response.count;
            return userPage;
        })
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getUsuario(usuarioId) {
        const url = `${this.usuariosUrl}/${usuarioId}`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getUsuarioForActivation(usuarioId, hash) {
        const url = `${this.usuariosUrl}/${usuarioId}/Activate/${hash}`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getSystems(usuarioId) {
        return this.http
            .get(`${this.usuariosUrl}/${usuarioId}/Sistemas`)
            .toPromise()
            .then((response) => response.sistemas.map((sistemaJSON) => Sistema.fromJSON(sistemaJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    logIn(model) {
        const url = `${this.usuariosUrl}/LogIn`;
        return this.http
            .post(url, JSON.stringify(model), { headers: this.headers })
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    create(usuario) {
        return this.http
            .post(this.usuariosUrl, JSON.stringify(usuario), {
            headers: this.headers,
        })
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(usuario) {
        const url = `${this.usuariosUrl}/${usuario.id}`;
        return this.http
            .put(url, JSON.stringify(usuario), { headers: this.headers })
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(id) {
        const url = `${this.usuariosUrl}/${id}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    activate(usuario, hash) {
        const url = `${this.usuariosUrl}/${usuario.id}/Activate/${hash}`;
        return this.http
            .put(url, JSON.stringify(usuario), { headers: this.headers })
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    forgotPassword(email) {
        const url = `${this.usuariosUrl}/ForgotPassword`;
        return this.http
            .post(url, JSON.stringify({ email }), { headers: this.headers })
            .toPromise()
            .then(() => { })
            .catch(this.errorHandlingService.handlePromiseError);
    }
    resetPassword(usuario, hash) {
        const url = `${this.usuariosUrl}/${usuario.id}/ResetPassword/${hash}`;
        return this.http
            .put(url, JSON.stringify(usuario), { headers: this.headers })
            .toPromise()
            .then((response) => Usuario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
UsuarioService.ɵfac = function UsuarioService_Factory(t) { return new (t || UsuarioService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
UsuarioService.ɵprov = ɵɵdefineInjectable({ token: UsuarioService, factory: UsuarioService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UsuarioService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();
class MyQueryEncoder extends HttpUrlEncodingCodec {
    encodeValue(v) {
        return encodeURIComponent(v);
    }
}

class AuthService {
    constructor(jwtHelper, usuarioService, router, libConfig) {
        this.jwtHelper = jwtHelper;
        this.usuarioService = usuarioService;
        this.router = router;
        this.libConfig = libConfig;
    }
    logIn(model) {
        return new Promise((resolve, reject) => {
            this.usuarioService
                .logIn(model)
                .then((usuario) => {
                localStorage.setItem('access_token', usuario.accessToken);
                resolve(usuario);
            })
                .catch((error) => reject(error));
        });
    }
    // This method will log the use out
    logout() {
        // To log out, just remove the token from local storage
        localStorage.removeItem('access_token');
        // Send the user back to the login page after logout
        this.router.navigate(['/login']);
    }
    loggedIn() {
        const rawToken = localStorage.getItem('access_token');
        return (this.jwtHelper.decodeToken(rawToken) &&
            (!this.jwtHelper.getTokenExpirationDate(rawToken) || !this.jwtHelper.isTokenExpired(rawToken)));
    }
    getUserId() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        return +token.sub;
    }
    isUserInRole(...roles) {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        const rolesFromToken = token.roles;
        if (rolesFromToken) {
            const rolesAry = rolesFromToken[this.libConfig.sistema];
            for (const role of roles) {
                if (rolesAry.find((str) => str.toLowerCase() === role.toLowerCase()) != null) {
                    return true;
                }
            }
        }
        return false;
    }
    getUserEstablecimientos() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        const establecimientos = token.establecimientos;
        if (establecimientos) {
            return establecimientos[this.libConfig.sistema];
        }
        else if (token.establecimiento) {
            return [token.establecimiento];
        }
        return null;
    }
    getUserOnlyEstablecimiento() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        const establecimientosToken = token.establecimientos;
        const establecimientos = establecimientosToken[this.libConfig.sistema];
        if (establecimientos && establecimientos.length === 1) {
            return establecimientos[0];
        }
        else if (token.establecimiento) {
            return token.establecimiento;
        }
        return null;
    }
    getUserCadena() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        const cadenaToken = token.cadena;
        return cadenaToken[this.libConfig.sistema];
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵɵinject(JwtHelperService), ɵɵinject(UsuarioService), ɵɵinject(Router), ɵɵinject(LibConfig)); };
AuthService.ɵprov = ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: JwtHelperService }, { type: UsuarioService }, { type: Router }, { type: LibConfig }]; }, null); })();

class AuthGuard {
    constructor(auth, document, config) {
        this.auth = auth;
        this.document = document;
        this.config = config;
    }
    canActivate() {
        // If user is not logged in we'll send them to the login page
        if (!this.auth.loggedIn()) {
            this.document.location.href = this.config.menuUrl;
        }
        return true;
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵɵinject(AuthService), ɵɵinject(DOCUMENT), ɵɵinject(LibConfig)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AuthService }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: LibConfig }]; }, null); })();

class CadenaService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.cadenasUrl = `${this.libConfig.baseUrl}/resources/Cadenas`; // URL to web api
    }
    getCadenas() {
        return this.http
            .get(`${this.cadenasUrl}/menu`)
            .toPromise()
            .then((response) => response.cadenas.map((cadenaJSON) => Cadena.fromJSON(cadenaJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getCadena(id) {
        return this.getCadenas().then((cadenas) => cadenas.find((cadena) => cadena.id === id));
    }
    getEstablecimientos(cadenaId, marcaId = null) {
        const url = `${this.cadenasUrl}/${cadenaId}` + (marcaId ? `/Marcas/${marcaId}` : ``) + `/Establecimientos/menu`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => response.establecimientos.map((json) => Establecimiento.fromJSON(json)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
CadenaService.ɵfac = function CadenaService_Factory(t) { return new (t || CadenaService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
CadenaService.ɵprov = ɵɵdefineInjectable({ token: CadenaService, factory: CadenaService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CadenaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class Cargo {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const cargo = new Cargo();
        cargo.id = json.id;
        cargo.nombre = json.nombre;
        return cargo;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class Persona {
    get nombreCompleto() {
        if (this.nombre && this.apellidos) {
            return this.nombre + ' ' + this.apellidos;
        }
        else if (this.nombre) {
            return this.nombre;
        }
        return '';
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const persona = new Persona();
        persona.id = json.id;
        persona.nombre = json.nombre;
        persona.apellidos = json.apellidos;
        persona.cargo = json.cargo ? Cargo.fromJSON(json.cargo) : null;
        persona.nif = json.nif;
        persona.numeroSeguridadSocial = json.numeroSeguridadSocial;
        persona.numeroCuentaBancaria = json.numeroCuentaBancaria;
        persona.domicilio = json.domicilio;
        persona.usuarios = json.usuarios ? json.usuarios.map((usuarioJSON) => Usuario.fromJSON(usuarioJSON)) : null;
        return persona;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            apellidos: this.apellidos,
            cargo: this.cargo ? this.cargo.toJSON() : null,
            nif: this.nif,
            numeroSeguridadSocial: this.numeroSeguridadSocial,
            numeroCuentaBancaria: this.numeroCuentaBancaria,
            domicilio: this.domicilio,
            usuarios: this.usuarios ? this.usuarios.map((usuario) => usuario.toJSON()) : null,
        };
    }
}

class TipoContacto {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const tipoContacto = new TipoContacto();
        tipoContacto.id = json.id;
        tipoContacto.nombre = json.nombre;
        return tipoContacto;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class ContactoSimple {
    constructor() {
        this.telefonos = [];
        this.emails = [];
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const contacto = new ContactoSimple();
        contacto.id = json.id;
        contacto.nombre = json.nombre;
        contacto.tipoContacto = json.tipoContacto ? TipoContacto.fromJSON(json.tipoContacto) : null;
        contacto.cadena = json.cadena ? Cadena.fromJSON(json.cadena) : null;
        contacto.establecimiento = json.establecimiento ? Establecimiento.fromJSON(json.establecimiento) : null;
        contacto.persona = json.persona ? Persona.fromJSON(json.persona) : null;
        contacto.telefonos = json.telefonos != null ? json.telefonos.map((telefono) => telefono) : null;
        contacto.emails = json.emails != null ? json.emails.map((email) => email) : null;
        return contacto;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            tipoContacto: this.tipoContacto ? this.tipoContacto.toJSON() : null,
            cadena: this.cadena ? this.cadena.toJSON() : null,
            establecimiento: this.establecimiento ? this.establecimiento.toJSON() : null,
            persona: this.persona ? this.persona.toJSON() : null,
            telefonos: this.telefonos != null ? this.telefonos.map((telefono) => telefono) : null,
            emails: this.emails != null ? this.emails.map((email) => email) : null,
        };
    }
}

class Etiqueta {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const etiqueta = new Etiqueta();
        etiqueta.id = json.id;
        etiqueta.nombre = json.nombre;
        return etiqueta;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
        };
    }
}

class Relacion {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const relacion = new Relacion();
        relacion.id = json.id;
        relacion.nombre = json.nombre;
        relacion.esUnica = json.esUnica;
        relacion.esActiva = json.esActiva;
        relacion.contactos = json.contactos ? json.contactos.map((contacto) => ContactoSimple.fromJSON(contacto)) : null;
        relacion.tipoContactoActivo = json.tipoContactoActivo;
        relacion.tipoContactoPasivo = json.tipoContactoPasivo;
        return relacion;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            esUnica: this.esUnica,
            esActiva: this.esActiva,
            contactos: this.contactos ? this.contactos.map((contacto) => contacto.toJSON()) : null,
            tipoContactoActivo: this.tipoContactoActivo,
            tipoContactoPasivo: this.tipoContactoPasivo,
        };
    }
}

class Contacto extends ContactoSimple {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const contacto = Object.assign(new Contacto(), super.fromJSON(json));
        contacto.observaciones = json.observaciones;
        contacto.paginaWeb = json.paginaWeb;
        contacto.relaciones = json.relaciones ? json.relaciones.map((relacion) => Relacion.fromJSON(relacion)) : null;
        contacto.etiquetas = json.etiquetas ? json.etiquetas.map((etiqueta) => Etiqueta.fromJSON(etiqueta)) : null;
        contacto.usuariosConPermiso = json.usuariosConPermiso
            ? json.usuariosConPermiso.map((usuario) => Usuario.fromJSON(usuario))
            : null;
        contacto.fecha = json.fecha ? moment(json.fecha, 'YYYY-MM-DD').toDate() : null;
        return contacto;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return Object.assign(super.toJSON(), {
            observaciones: this.observaciones,
            paginaWeb: this.paginaWeb,
            relaciones: this.relaciones ? this.relaciones.map((relacion) => relacion.toJSON()) : null,
            etiquetas: this.etiquetas ? this.etiquetas.map((etiqueta) => etiqueta.toJSON()) : null,
            usuariosConPermiso: this.usuariosConPermiso ? this.usuariosConPermiso.map((usuario) => usuario.toJSON()) : null,
            fecha: this.fecha ? moment(this.fecha).format('YYYY-MM-DD') : null,
        });
    }
}

class ContactoFilters {
}

class Comentario {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const comentario = new Comentario();
        comentario.id = json.id;
        comentario.texto = json.texto;
        comentario.fecha = json.fecha ? moment(json.fecha, 'YYYY-MM-DD').toDate() : null;
        comentario.usuario = json.usuario ? Usuario.fromJSON(json.usuario) : null;
        return comentario;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            texto: this.texto,
            fecha: this.fecha ? moment(this.fecha).format('YYYY-MM-DD') : null,
            usuario: this.usuario ? this.usuario.toJSON() : null,
        };
    }
}

class Nota {
    constructor() {
        this.nuevoComentario = new Comentario();
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const nota = new Nota();
        nota.id = json.id;
        nota.texto = json.texto;
        nota.fecha = json.fecha ? moment(json.fecha, 'YYYY-MM-DD').toDate() : null;
        nota.confidencial = json.confidencial;
        nota.contacto = json.contacto ? Contacto.fromJSON(json.contacto) : null;
        nota.usuario = json.usuario ? Usuario.fromJSON(json.usuario) : null;
        nota.interesados = json.interesados ? json.interesados.map((interesado) => Usuario.fromJSON(interesado)) : null;
        nota.comentarios = json.comentarios ? json.comentarios.map((comentario) => Comentario.fromJSON(comentario)) : null;
        return nota;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            texto: this.texto,
            fecha: this.fecha ? moment(this.fecha).format('YYYY-MM-DD') : null,
            confidencial: this.confidencial,
            contacto: this.contacto ? this.contacto.toJSON() : null,
            usuario: this.usuario ? this.usuario.toJSON() : null,
            interesados: this.interesados ? this.interesados.map((interesado) => interesado.toJSON()) : null,
            comentarios: this.comentarios ? this.comentarios.map((comentario) => comentario.toJSON()) : null,
        };
    }
}

class ContactoService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.contactosUrl = `${this.libConfig.baseUrl}/resources/Contactos`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getContactos(offset, limit, contactoFilters) {
        return this.http
            .get(`${this.contactosUrl}?page=${offset}&size=${limit}&${this.getQueryParams(contactoFilters)}`)
            .toPromise()
            .then((response) => response.contactos.map((contactoJSON) => Contacto.fromJSON(contactoJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getQueryParams(contactoFilters) {
        return this.queryParamKeyValues(contactoFilters)
            .reduce((httpParams, [key, value]) => (value == null ? httpParams : httpParams.set(key, value)), new HttpParams())
            .toString();
    }
    queryParamKeyValues(contactoFilters) {
        return [
            ['nombre', contactoFilters.nombre ? '' + contactoFilters.nombre : null],
            ['telefono', contactoFilters.telefono ? '' + contactoFilters.telefono : null],
            ['email', contactoFilters.email ? '' + contactoFilters.email : null],
            ['etiquetaId', contactoFilters.etiqueta ? '' + contactoFilters.etiqueta.id : null],
            ['cargoId', contactoFilters.cargo ? '' + contactoFilters.cargo.id : null],
        ];
    }
    searchContactos(term = null, tipoContactoId = null) {
        return this.http
            .get(this.contactosUrl + `/search/${term}` + `${tipoContactoId ? `?tipo=${tipoContactoId}` : ''}`)
            .pipe(map((response) => response.contactos.map((json) => Contacto.fromJSON(json))), catchError(this.errorHandlingService.handlePromiseError));
    }
    searchSimilarContactos(name = null, lastnames = null, shortName = null, nif = null, fiscalName = null, cif = null, contactType = null) {
        const params = this.getParams(name, lastnames, shortName, nif, fiscalName, cif, contactType);
        return this.http
            .get(this.contactosUrl + `/search-similar`, {
            params,
        })
            .pipe(map((response) => response.contactos.map((json) => Contacto.fromJSON(json))), catchError(this.errorHandlingService.handlePromiseError));
    }
    getParams(name = null, lastnames = null, shortName = null, nif = null, fiscalName = null, cif = null, contactType = null) {
        let params = new HttpParams({ encoder: new MyQueryEncoder$1() });
        if (name) {
            params = params.set('name', name);
        }
        if (lastnames) {
            params = params.set('lastnames', lastnames);
        }
        if (shortName) {
            params = params.set('shortName', shortName);
        }
        if (nif) {
            params = params.set('nif', nif);
        }
        if (fiscalName) {
            params = params.set('fiscalName', fiscalName);
        }
        if (cif) {
            params = params.set('cif', cif);
        }
        if (contactType) {
            params = params.set('type', contactType.toString());
        }
        return params;
    }
    get(contactoId) {
        const contactoUrl = `${this.contactosUrl}/${contactoId}?`;
        return this.http
            .get(contactoUrl)
            .toPromise()
            .then((response) => Contacto.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getNota(contactoId, notaId) {
        const notasUrl = `${this.contactosUrl}/${contactoId}/Notas`;
        const url = `${notasUrl}/${notaId}?`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => Nota.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getCargos() {
        return this.http
            .get(`${this.contactosUrl}/cargos`)
            .toPromise()
            .then((response) => response.cargos.map((cargoJSON) => Cargo.fromJSON(cargoJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getTiposCliente() {
        return this.http
            .get(`${this.contactosUrl}/tipos-cliente`)
            .toPromise()
            .then((response) => response.tiposCliente.map((tipoClienteJSON) => TipoCliente.fromJSON(tipoClienteJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getSectores() {
        return this.http
            .get(`${this.contactosUrl}/sectores`)
            .toPromise()
            .then((response) => response.sectores.map((sectorJSON) => Sector.fromJSON(sectorJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getEtiquetas() {
        return this.http
            .get(`${this.contactosUrl}/etiquetas`)
            .toPromise()
            .then((response) => response.etiquetas.map((sectorJSON) => Etiqueta.fromJSON(sectorJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getNotas(contactoId, page, size, sort, order) {
        const notasUrl = `${this.contactosUrl}/${contactoId}/Notas`;
        const url = `${notasUrl}?page=${page}&size=${size}` +
            (sort != null ? `&sort=${sort}` : ``) +
            (order != null ? `&order=${order}` : ``);
        return this.http
            .get(url)
            .toPromise()
            .then((response) => {
            const notasPage = new Page();
            notasPage.items = response.notas.map((json) => Nota.fromJSON(json));
            notasPage.count = response.count;
            return notasPage;
        })
            .catch(this.errorHandlingService.handlePromiseError);
    }
    create(contacto, logo) {
        return logo ? this.createMultipart(contacto, logo) : this.createJSON(contacto);
    }
    createMultipart(contacto, logo) {
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(contacto));
        return this.http
            .post(this.contactosUrl, formData)
            .toPromise()
            .then((response) => Contacto.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createJSON(contacto) {
        return this.http
            .post(this.contactosUrl, JSON.stringify(contacto), { headers: this.headers })
            .toPromise()
            .then((response) => Contacto.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createNota(contactoId, nota) {
        const notasUrl = `${this.contactosUrl}/${contactoId}/Notas`;
        return this.http
            .post(notasUrl, JSON.stringify(nota), { headers: this.headers })
            .toPromise()
            .then((response) => Nota.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createEtiqueta(etiqueta) {
        const url = `${this.contactosUrl}/etiquetas`;
        return this.http
            .post(url, JSON.stringify(etiqueta), { headers: this.headers })
            .toPromise()
            .then((response) => Etiqueta.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createComentario(nota) {
        const notasUrl = `${this.contactosUrl}/${nota.contacto.id}/Notas`;
        const url = `${notasUrl}/${nota.id}/comentarios`;
        return this.http
            .post(url, JSON.stringify(nota.nuevoComentario), { headers: this.headers })
            .toPromise()
            .then((response) => Comentario.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateContactosRelacionados(contacto) {
        const url = `${this.contactosUrl}/${contacto.id}/contactos-relacionados`;
        return this.http
            .put(url, JSON.stringify(contacto), { headers: this.headers })
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateUsuariosConPermiso(contactoId, usuarios) {
        const url = `${this.contactosUrl}/${contactoId}/usuarios-permiso`;
        return this.http
            .put(url, JSON.stringify(usuarios), { headers: this.headers })
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(contacto, logo) {
        return logo ? this.updateMultipart(contacto, logo) : this.updateJSON(contacto);
    }
    updateJSON(contacto) {
        const url = `${this.contactosUrl}/${contacto.id}`;
        return this.http
            .put(url, JSON.stringify(contacto), { headers: this.headers })
            .toPromise()
            .then((response) => Contacto.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateMultipart(contacto, logo) {
        const url = `${this.contactosUrl}/${contacto.id}`;
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(contacto));
        return this.http
            .put(url, formData)
            .toPromise()
            .then((response) => Contacto.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateNota(contactoId, nota) {
        const notasUrl = `${this.contactosUrl}/${contactoId}/Notas`;
        const url = `${notasUrl}/${nota.id}`;
        return this.http
            .put(url, JSON.stringify(nota), { headers: this.headers })
            .toPromise()
            .then((response) => Nota.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(contacto) {
        const contactoUrl = `${this.contactosUrl}/${contacto.id}?`;
        const url = `${contactoUrl}${this.handleGetContactoQueryParams(contacto)}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    deleteNota(contactoId, notaId) {
        const notasUrl = `${this.contactosUrl}/${contactoId}/Notas`;
        const url = `${notasUrl}/${notaId}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    handleGetContactoQueryParams(contacto) {
        if (contacto.persona) {
            return `personaId=${contacto.persona.id}`;
        }
        else if (contacto.cadena) {
            return `cadenaId=${contacto.cadena.id}`;
        }
        else {
            return `establecimientoId=${contacto.establecimiento.id}`;
        }
    }
}
ContactoService.ɵfac = function ContactoService_Factory(t) { return new (t || ContactoService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
ContactoService.ɵprov = ɵɵdefineInjectable({ token: ContactoService, factory: ContactoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContactoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();
class MyQueryEncoder$1 extends HttpUrlEncodingCodec {
    encodeValue(v) {
        return encodeURIComponent(v);
    }
}

class Departamento {
    get conLugar() {
        return DatabaseConstants.getInstance().deptConLugarIds.indexOf(this.id) > -1;
    }
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const departamento = new Departamento();
        departamento.id = json.id;
        departamento.nombre = json.nombre;
        departamento.url = json.url;
        return departamento;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            url: this.url,
            orden: this.orden,
        };
    }
}

class DepartamentoService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.departamentosUrl = `${this.libConfig.baseUrl}/resources/Departamentos`;
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getDepartamentos(sort = null) {
        return this.http
            .get(`${this.departamentosUrl}${sort ? `?sort=${sort}` : ''}`)
            .toPromise()
            .then((response) => response.departamentos.map((departamentoJSON) => Departamento.fromJSON(departamentoJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getDepartamento(id) {
        return this.getDepartamentos().then((departamentos) => departamentos.find((departamento) => departamento.id === id));
    }
    create(departamento, logo) {
        return logo ? this.createMultipart(departamento, logo) : this.createJSON(departamento);
    }
    createMultipart(departamento, logo) {
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(departamento));
        return this.http
            .post(this.departamentosUrl, formData)
            .toPromise()
            .then((response) => Departamento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createJSON(departamento) {
        return this.http
            .post(this.departamentosUrl, JSON.stringify(departamento), { headers: this.headers })
            .toPromise()
            .then((response) => Departamento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(departamento, logo) {
        return logo ? this.updateMultipart(departamento, logo) : this.updateJSON(departamento);
    }
    updateMultipart(departamento, logo) {
        const url = `${this.departamentosUrl}/${departamento.id}`;
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(departamento));
        return this.http
            .put(url, formData)
            .toPromise()
            .then((response) => Departamento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateJSON(departamento) {
        const url = `${this.departamentosUrl}/${departamento.id}`;
        return this.http
            .put(url, JSON.stringify(departamento), { headers: this.headers })
            .toPromise()
            .then((response) => Departamento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(id) {
        const url = `${this.departamentosUrl}/${id}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
DepartamentoService.ɵfac = function DepartamentoService_Factory(t) { return new (t || DepartamentoService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
DepartamentoService.ɵprov = ɵɵdefineInjectable({ token: DepartamentoService, factory: DepartamentoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DepartamentoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class Dimension {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const dimension = new Dimension();
        dimension.id = json.id;
        dimension.nombre = json.nombre;
        dimension.url = json.url;
        dimension.descripcion = json.descripcion;
        if (json.subdimensiones != null) {
            dimension.subdimensiones = json.subdimensiones.map((dimensionJSON) => {
                const subdimension = Dimension.fromJSON(dimensionJSON);
                subdimension.superdimension = dimension;
                return subdimension;
            });
        }
        return dimension;
    }
    static flatten(dimensiones, level = 0) {
        let result = [];
        for (const dimension of dimensiones) {
            result.push(dimension);
            result = result.concat(this.flatten(dimension.subdimensiones, level + 1));
        }
        return result;
    }
    getLevel() {
        let level = 0;
        let dim = this;
        while (dim.superdimension != null) {
            dim = dim.superdimension;
            level += 1;
        }
        return level;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return {
            id: this.id,
            nombre: this.nombre,
            url: this.url,
            descripcion: this.descripcion,
            orden: this.orden,
            superdimension: this.superdimension != null ? this.superdimension.toJSON() : null,
            subdimensiones: null,
        };
    }
    isSelfOrChildren(dimensionId) {
        if (this.id === dimensionId) {
            return true;
        }
        if (this.subdimensiones) {
            for (const subdimension of this.subdimensiones) {
                if (subdimension.isSelfOrChildren(dimensionId)) {
                    return true;
                }
            }
        }
        return false;
    }
}

class DimensionService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.dimensionesUrl = `${this.libConfig.baseUrl}/resources/Dimensiones`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getDimensiones() {
        return this.http
            .get(this.dimensionesUrl)
            .toPromise()
            .then((response) => response.dimensiones.map((dimensionJSON) => Dimension.fromJSON(dimensionJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    create(dimension, logo) {
        return logo ? this.createMultipart(dimension, logo) : this.createJSON(dimension);
    }
    createMultipart(dimension, logo) {
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(dimension));
        return this.http
            .post(this.dimensionesUrl, formData)
            .toPromise()
            .then((response) => Dimension.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createJSON(dimension) {
        return this.http
            .post(this.dimensionesUrl, JSON.stringify(dimension), { headers: this.headers })
            .toPromise()
            .then((response) => Dimension.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(dimension, logo) {
        return logo ? this.updateMultipart(dimension, logo) : this.updateJSON(dimension);
    }
    updateMultipart(dimension, logo) {
        const url = `${this.dimensionesUrl}/${dimension.id}`;
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(dimension));
        return this.http
            .put(url, formData)
            .toPromise()
            .then((response) => Dimension.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateJSON(dimension) {
        const url = `${this.dimensionesUrl}/${dimension.id}`;
        return this.http
            .put(url, JSON.stringify(dimension), { headers: this.headers })
            .toPromise()
            .then((response) => Dimension.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(id) {
        const url = `${this.dimensionesUrl}/${id}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getDimension(id) {
        const url = `${this.dimensionesUrl}/${id}`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => Dimension.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
DimensionService.ɵfac = function DimensionService_Factory(t) { return new (t || DimensionService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
DimensionService.ɵprov = ɵɵdefineInjectable({ token: DimensionService, factory: DimensionService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DimensionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class EstablecimientoService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.establecimientosUrl = `${this.libConfig.baseUrl}/resources/Establecimientos`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getEstablecimientos(page, size, sort, order, cadena = null, zona = null) {
        const url = `${this.establecimientosUrl}/${this.libConfig.sistema}?page=${page}&size=${size}` +
            (sort != null ? `&sort=${sort}` : ``) +
            (order != null ? `&order=${order}` : ``) +
            (cadena != null ? `&cadena=${cadena.id}` : ``) +
            (zona != null ? `&zona=${zona.id}` : ``);
        return this.http
            .get(url)
            .toPromise()
            .then((response) => {
            const establishmentPage = new Page();
            establishmentPage.items = response.establecimientos.map((json) => Establecimiento.fromJSON(json));
            establishmentPage.count = response.count;
            return establishmentPage;
        })
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getEstablecimiento(establecimientoId) {
        const url = `${this.establecimientosUrl}/${establecimientoId}/${this.libConfig.sistema}`;
        return this.http
            .get(url)
            .toPromise()
            .then((response) => Establecimiento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    create(establecimiento) {
        const url = `${this.establecimientosUrl}`;
        return this.http
            .post(url, JSON.stringify(establecimiento), { headers: this.headers })
            .toPromise()
            .then((response) => Establecimiento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(establecimiento) {
        const url = `${this.establecimientosUrl}/${establecimiento.id}`;
        return this.http
            .put(url, JSON.stringify(establecimiento), { headers: this.headers })
            .toPromise()
            .then((response) => Establecimiento.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(id) {
        const url = `${this.establecimientosUrl}/${id}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
EstablecimientoService.ɵfac = function EstablecimientoService_Factory(t) { return new (t || EstablecimientoService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
EstablecimientoService.ɵprov = ɵɵdefineInjectable({ token: EstablecimientoService, factory: EstablecimientoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EstablecimientoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class MarcaService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.cadenasUrl = `${this.libConfig.baseUrl}/resources/Cadenas`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    create(marca, logo, cadenaId) {
        return logo ? this.createMultipart(marca, logo, cadenaId) : this.createJSON(marca, cadenaId);
    }
    createMultipart(marca, logo, cadenaId) {
        const url = `${this.cadenasUrl}/${cadenaId}/Marcas`;
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(marca));
        return this.http
            .post(url, formData)
            .toPromise()
            .then((response) => Marca.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    createJSON(marca, cadenaId) {
        const url = `${this.cadenasUrl}/${cadenaId}/Marcas`;
        return this.http
            .post(url, JSON.stringify(marca), { headers: this.headers })
            .toPromise()
            .then((response) => Marca.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(marca, logo, cadenaId) {
        return logo ? this.updateMultipart(marca, logo, cadenaId) : this.updateJSON(marca, cadenaId);
    }
    updateMultipart(marca, logo, cadenaId) {
        const url = `${this.cadenasUrl}/${cadenaId}/Marcas/${marca.id}`;
        const formData = new FormData();
        formData.append('logo', logo);
        formData.append('json', JSON.stringify(marca));
        return this.http
            .put(url, formData)
            .toPromise()
            .then((response) => Marca.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    updateJSON(marca, cadenaId) {
        const url = `${this.cadenasUrl}/${cadenaId}/Marcas/${marca.id}`;
        return this.http
            .put(url, JSON.stringify(marca), { headers: this.headers })
            .toPromise()
            .then((response) => Marca.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(marcaId, cadenaId) {
        const url = `${this.cadenasUrl}/${cadenaId}/Marcas/${marcaId}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
MarcaService.ɵfac = function MarcaService_Factory(t) { return new (t || MarcaService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
MarcaService.ɵprov = ɵɵdefineInjectable({ token: MarcaService, factory: MarcaService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MarcaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class ElementoPosicionGlobal {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const posicionGlobal = new ElementoPosicionGlobal();
        posicionGlobal.icon = json.icon;
        posicionGlobal.descripcion = json.descripcion;
        posicionGlobal.gauge = json.gauge;
        posicionGlobal.periodoActual = json.periodoActual;
        posicionGlobal.periodoAnterior = json.periodoAnterior;
        posicionGlobal.muestraActual = json.muestraActual;
        posicionGlobal.muestraAnterior = json.muestraAnterior;
        posicionGlobal.mediaMarca = json.mediaMarca;
        posicionGlobal.mediaMercado = json.mediaMercado;
        posicionGlobal.liderSector = json.liderSector;
        posicionGlobal.rankingMarca = json.rankingMarca;
        posicionGlobal.rankingMercado = json.rankingMercado;
        return posicionGlobal;
    }
}

class PosicionGlobal {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const posicionGlobal = new PosicionGlobal();
        posicionGlobal.elementos = json.elementos
            ? json.elementos.map((elementoJSON) => ElementoPosicionGlobal.fromJSON(elementoJSON))
            : [];
        return posicionGlobal;
    }
}

class PosicionGlobalService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.posicionGlobalUrl = `${this.libConfig.baseUrl}/resources/PosicionGlobal`; // URL to web api
    }
    getPosicionGlobal(fechaIni, fechaFin, establecimientoId) {
        const fechaIniStr = moment(fechaIni).format('YYYY-MM-DD');
        const fechaFinStr = moment(fechaFin).format('YYYY-MM-DD');
        return this.http
            .get(`${this.posicionGlobalUrl}?fechaIni=${fechaIniStr}&fechaFin=${fechaFinStr}&establecimientoId=${establecimientoId}`)
            .toPromise()
            .then((response) => PosicionGlobal.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
PosicionGlobalService.ɵfac = function PosicionGlobalService_Factory(t) { return new (t || PosicionGlobalService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
PosicionGlobalService.ɵprov = ɵɵdefineInjectable({ token: PosicionGlobalService, factory: PosicionGlobalService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PosicionGlobalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class SaveService {
    constructor(document) {
        this.document = document;
    }
    save(file) {
        const url = URL.createObjectURL(file);
        const link = this.document.createElement('a');
        link.style.display = 'none';
        // It seems that the latest versions of Chrome intentionally ignore the download attribute on cross-origin
        // links according to W3C recommendation
        // https://stackoverflow.com/questions/23962284/download-attribute-on-a-tag-doesnt-work-in-chrome
        link.download = this.safeFilename(file.name);
        link.href = url;
        // attach to DOM otherwise this does not work in Firefox
        this.document.body.appendChild(link);
        link.click();
        // delay on remove otherwise does not work in Firefox
        setTimeout(() => {
            this.document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, 0);
    }
    safeFilename(name) {
        let filename = name;
        filename = filename.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        filename = filename.replace(/[ \/]+/g, '_');
        filename = filename.replace(/[^a-zA-Z0-9.,_-]+/g, '');
        return filename;
    }
}
SaveService.ɵfac = function SaveService_Factory(t) { return new (t || SaveService)(ɵɵinject(DOCUMENT)); };
SaveService.ɵprov = ɵɵdefineInjectable({ token: SaveService, factory: SaveService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SaveService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class TipoEstablecimientoService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.tiposEstablecimientoUrl = `${this.libConfig.baseUrl}/resources/TiposEstablecimiento`;
    }
    getTiposEstablecimiento() {
        return this.http
            .get(this.tiposEstablecimientoUrl)
            .toPromise()
            .then((response) => response.tiposEstablecimiento.map((json) => TipoEstablecimiento.fromJSON(json)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
}
TipoEstablecimientoService.ɵfac = function TipoEstablecimientoService_Factory(t) { return new (t || TipoEstablecimientoService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
TipoEstablecimientoService.ɵprov = ɵɵdefineInjectable({ token: TipoEstablecimientoService, factory: TipoEstablecimientoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TipoEstablecimientoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class ZonaService {
    constructor(http, libConfig, errorHandlingService) {
        this.http = http;
        this.libConfig = libConfig;
        this.errorHandlingService = errorHandlingService;
        this.zonasUrl = `${this.libConfig.baseUrl}/resources/Zonas`; // URL to web api
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    getZonas() {
        return this.http
            .get(this.zonasUrl)
            .toPromise()
            .then((response) => response.zonas.map((zonaJSON) => Zona.fromJSON(zonaJSON)))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    update(zona) {
        const url = `${this.zonasUrl}/${zona.id}`;
        return this.http
            .put(url, JSON.stringify(zona), { headers: this.headers })
            .toPromise()
            .then(() => zona)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    create(zona) {
        return this.http
            .post(this.zonasUrl, JSON.stringify(zona), { headers: this.headers })
            .toPromise()
            .then((response) => Zona.fromJSON(response))
            .catch(this.errorHandlingService.handlePromiseError);
    }
    delete(id) {
        const url = `${this.zonasUrl}/${id}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(() => null)
            .catch(this.errorHandlingService.handlePromiseError);
    }
    getZona(id) {
        return this.getZonas().then((zonas) => this.findInTree(id, zonas));
    }
    findInTree(id, zonas) {
        for (const zona of zonas) {
            if (zona.id === id) {
                return zona;
            }
            const subzona = this.findInTree(id, zona.subzonas);
            if (subzona != null) {
                return subzona;
            }
        }
        return null;
    }
}
ZonaService.ɵfac = function ZonaService_Factory(t) { return new (t || ZonaService)(ɵɵinject(HttpClient), ɵɵinject(LibConfig), ɵɵinject(ErrorHandlingService)); };
ZonaService.ɵprov = ɵɵdefineInjectable({ token: ZonaService, factory: ZonaService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ZonaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }, { type: LibConfig }, { type: ErrorHandlingService }]; }, null); })();

class CoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
CoreModule.ɵmod = ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = ɵɵdefineInjector({ factory: function CoreModule_Factory(t) { return new (t || CoreModule)(ɵɵinject(CoreModule, 12)); }, providers: [
        DepartamentoService,
        DimensionService,
        CadenaService,
        ContactoService,
        EstablecimientoService,
        MarcaService,
        PosicionGlobalService,
        TipoEstablecimientoService,
        ZonaService,
        UsuarioService,
        AuthGuard,
        AuthService,
        ErrorHandlingService,
        SaveService,
        LibConfig,
    ], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CoreModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CoreModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [],
                providers: [
                    DepartamentoService,
                    DimensionService,
                    CadenaService,
                    ContactoService,
                    EstablecimientoService,
                    MarcaService,
                    PosicionGlobalService,
                    TipoEstablecimientoService,
                    ZonaService,
                    UsuarioService,
                    AuthGuard,
                    AuthService,
                    ErrorHandlingService,
                    SaveService,
                    LibConfig,
                ],
            }]
    }], function () { return [{ type: CoreModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class NotaDashboard {
    static fromJSON(json) {
        const notaDashboard = new NotaDashboard();
        notaDashboard.nota = json.nota;
        notaDashboard.notaAnterior = json.notaAnterior;
        notaDashboard.objetivo = json.objetivo;
        return notaDashboard;
    }
    toJSON() {
        return {
            nota: this.nota,
            notaAnterior: this.notaAnterior,
            objetivo: this.objetivo,
        };
    }
}

class NotaSicDashboard extends NotaDashboard {
    // fromJSON is used to convert a serialized version
    // of the object to an instance of the class
    static fromJSON(json) {
        const notaSicDashboard = Object.assign(new NotaSicDashboard(), super.fromJSON(json));
        notaSicDashboard.numQuejas = json.numQuejas;
        notaSicDashboard.numFelicitaciones = json.numFelicitaciones;
        notaSicDashboard.numQuejasAnterior = json.numQuejasAnterior;
        notaSicDashboard.numFelicitacionesAnterior = json.numFelicitacionesAnterior;
        return notaSicDashboard;
    }
    // toJSON is automatically used by JSON.stringify
    toJSON() {
        return Object.assign(super.toJSON(), {
            numQuejas: this.numQuejas,
            numFelicitaciones: this.numFelicitaciones,
            numQuejasAnterior: this.numQuejasAnterior,
            numFelicitacionesAnterior: this.numFelicitacionesAnterior,
        });
    }
}

class RoutingUtils {
    // Matrix parameters are tied to a path segment, while query parameters are tied to the URL
    // e.g. localhost:3000/heroes;id=15;foo=foo/bar/baz
    static mergeMatrixParams(router, route, params) {
        const obj = Object.assign({}, route.snapshot.params, params);
        Object.keys(obj).forEach((key) => !obj[key] && delete obj[key]);
        // https://stackoverflow.com/questions/41205929/how-to-update-matrix-parameters-in-angular2
        const newUrl = router.createUrlTree([obj], { relativeTo: route });
        router.navigateByUrl(newUrl, { replaceUrl: true });
    }
    static replaceMatrixParams(router, route, params) {
        router.navigate(['.', params], { relativeTo: route, replaceUrl: true });
    }
}

function emailValidator() {
    return (control) => {
        const value = control.value;
        const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        return EMAIL_REGEXP.test(value) ? null : { validateEmail: { value } };
    };
}
class EmailValidatorDirective {
    constructor() {
        this.valFn = emailValidator();
    }
    validate(control) {
        return this.valFn(control);
    }
}
EmailValidatorDirective.ɵfac = function EmailValidatorDirective_Factory(t) { return new (t || EmailValidatorDirective)(); };
EmailValidatorDirective.ɵdir = ɵɵdefineDirective({ type: EmailValidatorDirective, selectors: [["", "validateEmail", ""]], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALIDATORS,
                useExisting: EmailValidatorDirective,
                multi: true,
            },
        ])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EmailValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[validateEmail]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: EmailValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();

function equalValidator(validateEqual) {
    return (c) => {
        // self value (e.g. retype password)
        const v = c.value;
        // control value (e.g. password)
        const e = validateEqual;
        return v && e && v === e ? null : { validateEqual: false };
    };
}
class EqualValidatorDirective {
    constructor(injector) {
        this.injector = injector;
        this.valFn = Validators.nullValidator;
    }
    ngOnChanges(changes) {
        const change = changes.validateEqual;
        if (change) {
            this.valFn = equalValidator(change.currentValue);
            this.injector.get(NgControl).control.updateValueAndValidity();
        }
    }
    validate(control) {
        return this.valFn(control);
    }
}
EqualValidatorDirective.ɵfac = function EqualValidatorDirective_Factory(t) { return new (t || EqualValidatorDirective)(ɵɵdirectiveInject(Injector)); };
EqualValidatorDirective.ɵdir = ɵɵdefineDirective({ type: EqualValidatorDirective, selectors: [["", "validateEqual", ""]], inputs: { validateEqual: "validateEqual" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALIDATORS,
                useExisting: EqualValidatorDirective,
                multi: true,
            },
        ]), ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EqualValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[validateEqual]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: EqualValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: Injector }]; }, { validateEqual: [{
            type: Input
        }] }); })();

class FocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    setFocus(hasFocus) {
        if (hasFocus) {
            this.elementRef.nativeElement.focus();
        }
        else {
            this.elementRef.nativeElement.blur();
        }
    }
}
FocusDirective.ɵfac = function FocusDirective_Factory(t) { return new (t || FocusDirective)(ɵɵdirectiveInject(ElementRef)); };
FocusDirective.ɵdir = ɵɵdefineDirective({ type: FocusDirective, selectors: [["", "focusable", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FocusDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[focusable]',
            }]
    }], function () { return [{ type: ElementRef }]; }, null); })();

class MaxValidatorDirective {
    validate(control) {
        return Validators.max(this.max)(control);
    }
}
MaxValidatorDirective.ɵfac = function MaxValidatorDirective_Factory(t) { return new (t || MaxValidatorDirective)(); };
MaxValidatorDirective.ɵdir = ɵɵdefineDirective({ type: MaxValidatorDirective, selectors: [["", "max", ""]], inputs: { max: "max" }, features: [ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MaxValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[max]',
                providers: [{ provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }],
            }]
    }], null, { max: [{
            type: Input
        }] }); })();

class MinValidatorDirective {
    validate(control) {
        return Validators.min(this.min)(control);
    }
}
MinValidatorDirective.ɵfac = function MinValidatorDirective_Factory(t) { return new (t || MinValidatorDirective)(); };
MinValidatorDirective.ɵdir = ɵɵdefineDirective({ type: MinValidatorDirective, selectors: [["", "min", ""]], inputs: { min: "min" }, features: [ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MinValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[min]',
                providers: [{ provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }],
            }]
    }], null, { min: [{
            type: Input
        }] }); })();

// tslint:disable-next-line:directive-selector
class RepeatDirective {
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    set count(c) {
        this.viewContainer.clear();
        for (let i = 0; i < c; i++) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
RepeatDirective.ɵfac = function RepeatDirective_Factory(t) { return new (t || RepeatDirective)(ɵɵdirectiveInject(TemplateRef), ɵɵdirectiveInject(ViewContainerRef)); };
RepeatDirective.ɵdir = ɵɵdefineDirective({ type: RepeatDirective, selectors: [["", "repeat", ""]], inputs: { count: ["repeat", "count"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RepeatDirective, [{
        type: Directive,
        args: [{ selector: '[repeat]' }]
    }], function () { return [{ type: TemplateRef }, { type: ViewContainerRef }]; }, { count: [{
            type: Input,
            args: ['repeat']
        }] }); })();

function selectValidator() {
    return (control) => {
        const value = control.value;
        return value == null ? { validateSelect: { value } } : null;
    };
}
class SelectValidatorDirective {
    constructor() {
        this.valFn = selectValidator();
    }
    validate(control) {
        return this.valFn(control);
    }
}
SelectValidatorDirective.ɵfac = function SelectValidatorDirective_Factory(t) { return new (t || SelectValidatorDirective)(); };
SelectValidatorDirective.ɵdir = ɵɵdefineDirective({ type: SelectValidatorDirective, selectors: [["", "validateSelect", ""]], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALIDATORS,
                useExisting: SelectValidatorDirective,
                multi: true,
            },
        ])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[validateSelect]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: SelectValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();

class SharedModule {
}
SharedModule.ɵmod = ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = ɵɵdefineInjector({ factory: function SharedModule_Factory(t) { return new (t || SharedModule)(); }, providers: [
    /* Do not specify app-wide singleton providers in a shared module. A lazy loaded
     * module that imports that shared module will make its own copy of the service.
     */
    ], imports: [[CommonModule],
        CommonModule,
        FormsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SharedModule, { declarations: [EmailValidatorDirective,
        SelectValidatorDirective,
        EqualValidatorDirective,
        MinValidatorDirective,
        MaxValidatorDirective,
        RepeatDirective,
        FocusDirective], imports: [CommonModule], exports: [EmailValidatorDirective,
        SelectValidatorDirective,
        EqualValidatorDirective,
        MinValidatorDirective,
        MaxValidatorDirective,
        RepeatDirective,
        FocusDirective,
        CommonModule,
        FormsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    EmailValidatorDirective,
                    SelectValidatorDirective,
                    EqualValidatorDirective,
                    MinValidatorDirective,
                    MaxValidatorDirective,
                    RepeatDirective,
                    FocusDirective,
                ],
                exports: [
                    EmailValidatorDirective,
                    SelectValidatorDirective,
                    EqualValidatorDirective,
                    MinValidatorDirective,
                    MaxValidatorDirective,
                    RepeatDirective,
                    FocusDirective,
                    CommonModule,
                    FormsModule,
                ],
                providers: [
                /* Do not specify app-wide singleton providers in a shared module. A lazy loaded
                 * module that imports that shared module will make its own copy of the service.
                 */
                ],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuthGuard, AuthService, Cadena, CadenaService, Cargo, Comentario, Contacto, ContactoFilters, ContactoService, ContactoSimple, CoreModule, DatabaseConstants, Departamento, DepartamentoService, Dimension, DimensionService, ElementoPosicionGlobal, EmailValidatorDirective, EqualValidatorDirective, ErrorHandlingService, Establecimiento, EstablecimientoService, Etiqueta, FocusDirective, LibConfig, Marca, MarcaService, MaxValidatorDirective, MinValidatorDirective, Nota, NotaDashboard, NotaSicDashboard, Page, Persona, PosicionGlobal, PosicionGlobalService, Relacion, RepeatDirective, RoutingUtils, SaveService, Sector, SelectValidatorDirective, SharedModule, Sistema, TipoCliente, TipoContacto, TipoEstablecimiento, TipoEstablecimientoService, Usuario, UsuarioService, UsuarioSimple, UsuarioSistema, Zona, ZonaService };
//# sourceMappingURL=emc2-lib.js.map
